import React, {PureComponent} from "react";
import {translate} from "admin-on-rest";

class Interpolations extends PureComponent {
  render() {
    const {translate, interpolations} = this.props;

    return (
      <div style={{padding: "0 7px"}}>
        <p>
          {translate("resources.interpolations.instructions")}
          
        </p>
        <p>
          {translate("resources.interpolations.supported")}
          
        </p>
        {
          interpolations.map((group, i) => <ul key={i}>
            {group.map((interpolation, i) => <li key={i}>{'{{'} {interpolation} {'}}'}</li>)}
          </ul>)
        }
      </div>
    );
  }
}

Interpolations.propTypes = {
};

export default translate(Interpolations);



// WEBPACK FOOTER //
// ./src/components/Interpolations.js